import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './option-with-description-renderer.less';

const OptionWithDescriptionRenderer = ({ label, description }) => (
  <dl className={classnames(styles.root)}>
    <dt className={classnames(styles.label)}>{label}</dt>
    <dd className={classnames(styles.description)}>{description}</dd>
  </dl>
);

OptionWithDescriptionRenderer.propTypes = {
  label: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default OptionWithDescriptionRenderer;
export { OptionWithDescriptionRenderer };
